import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import HomePage from './pages/HomePage';
import ResultPage from './pages/ResultPage';
import UpgradePage from './pages/UpgradePage';
import AuthPage from './pages/AuthPage';
import SettingsPage from './pages/SettingsPage';

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/result" element={<ResultPage />} />
                    <Route path="/upgrade" element={<UpgradePage />} />
                    <Route path="/auth" element={<AuthPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}
